import React, { createRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Card, Tooltip, Typography } from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined'

import { attributesNames, colorTypes, userRightTypes } from '../../../../constants'
import { DebugView, Logger, LoggerTypes } from '../../../../utils'
import { DialogDelete, AccessControl } from '../../../../components'
import { AttributeWeatherDialogUpdate } from '../dialogs'
import '../../style-common-card.scss'

export const AttributeWeatherCard = ({
  currentProject,
  currentScenario,
  weather,
  actionDispatchUpdate,
  actionDispatchDelete
}) => {
  const { t } = useTranslation()
  const ref = createRef()

  const [openDialogUpdate, setOpenDialogUpdate] = useState(false)
  const [openDialogDelete, setOpenDialogDelete] = useState(false)

  const onDialogUpdateOpen = () => {
    Logger.trace(LoggerTypes.CONTROLLER, 'AttributeWeatherCard.onOpenDialog()')
    setOpenDialogUpdate(true)
  }

  const onDialogDeleteOpen = () => {
    Logger.trace(LoggerTypes.CONTROLLER, 'AttributeWeatherCard.onOpenDialogDelete()')
    setOpenDialogDelete(true)
  }

  // Logger.trace(LoggerTypes.CONTAINER, 'AttributeWeatherCard.render()', {
  //   currentProject,
  //   currentScenario,
  //   weather,
  // })

  return (
    currentProject && (
      <Card className="common-card">
        <div className="common-card-header">
          <Typography className="common-card-header-name" variant="subtitle2" color={colorTypes.PRIMARY}>
            {weather.name || 'N/A'}
          </Typography>
          <div className="common-card-header-icon">
            {/* -- Button EDIT -- */}
            <AccessControl userPermissions={[userRightTypes.PROJECT_ATTRIBUTES_EDIT]} renderNoAccess={() => <></>}>
              {actionDispatchUpdate && (
                <Tooltip ref={ref} title={t('common.update')}>
                  <ModeEditOutlineOutlinedIcon
                    onClick={onDialogUpdateOpen}
                    color={colorTypes.PRIMARY}
                    className="buttons-edit-icon"
                  />
                </Tooltip>
              )}
            </AccessControl>

            {/* -- Button DELETE -- */}
            <AccessControl userPermissions={[userRightTypes.PROJECT_ATTRIBUTES_DELETE]} renderNoAccess={() => <></>}>
              {actionDispatchDelete && (
                <Tooltip ref={ref} title={t('common.delete')}>
                  <DeleteOutlineIcon
                    onClick={onDialogDeleteOpen}
                    color={colorTypes.PRIMARY}
                    className="buttons-edit-icon"
                  />
                </Tooltip>
              )}
            </AccessControl>

            {openDialogUpdate && actionDispatchUpdate && (
              <AttributeWeatherDialogUpdate
                currentProject={currentProject}
                currentScenario={currentScenario}
                actionUpdateDispatch={actionDispatchUpdate}
                openDialog={openDialogUpdate}
                setOpenDialog={setOpenDialogUpdate}
                weather={weather}
              />
            )}
            {openDialogDelete && actionDispatchDelete && (
              <DialogDelete
                title={t('attributes.weather_data.delete.title')}
                message={t('attributes.weather_data.delete.description')}
                projectId={currentProject?.id}
                scenarioId={currentScenario?.id}
                actionDispatchDelete={actionDispatchDelete}
                openDialog={openDialogDelete}
                setOpenDialog={setOpenDialogDelete}
                variable={weather}
              />
            )}
          </div>
        </div>
        <div className="common-card-description">{weather.description}</div>
        <div className="common-card-list"></div>
        <DebugView type={attributesNames.WEATHER_DATA}>{weather}</DebugView>
      </Card>
    )
  )
}

AttributeWeatherCard.displayName = 'AttributeWeatherCard'

AttributeWeatherCard.propTypes = {
  weather: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string
  }).isRequired,
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object,
  actionDispatchUpdate: PropTypes.func,
  actionDispatchDelete: PropTypes.func
}

AttributeWeatherCard.defaultProps = {
  weather: null,
  currentProject: null,
  currentScenario: null,
  actionDispatchUpdate: null,
  actionDispatchDelete: null
}
